function sizeAccordionLogic() {
    const sizeButton = document.querySelector('[data-size-filter]');
    const accordions = document.querySelectorAll('.collapsible-toggle');

    if (sizeButton && accordions) {
        sizeButton.addEventListener('click', function() {
            accordions.forEach(accordion => {
                const content = document.getElementById(accordion.getAttribute('aria-controls'));
                if (content) {
                    accordion.setAttribute('aria-expanded', 'false');
                    content.removeAttribute('open');
                }
            });

            const sizeAccordion = document.querySelector('.collapsible-toggle[aria-controls="facet-filter-filter.v.option.size"]');
            if (sizeAccordion) {
                const sizeContent = document.getElementById(sizeAccordion.getAttribute('aria-controls'));
                if (sizeContent) {
                    sizeAccordion.setAttribute('aria-expanded', 'true');
                    sizeContent.setAttribute('open', '');
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', sizeAccordionLogic);
